import React, { Component, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Route, withRouter, useLocation } from "react-router-dom";
import { Footer } from "~/components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import { createStructuredSelector } from "reselect";
import { FormattedMessage, defineMessages } from "react-intl";
import { selectors as appSelectors } from "../App";
import { selectors as reservationSelectors } from "../ReservationManager";
import { selectors as checkoutSelectors } from "../Checkout";
import { actions } from "./reducer";
import { actions as appActions } from "../App";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { reservationSelector } from "../App/selectors";
import {
  ResultHeader as ModficationResultHeader,
  ModificationButtonBar,
  ModifyReservationChangesSummary,
  ModifyReservationWizardDates,
  ModifyReservationWizardAccommodation,
  ModifyReservationWizardExtras,
  PriceBreakdown,
  Conditions,
} from "@witbooking/react-components";

import {
  accommodationSelector,
  accommodationModificationRestrictionTypeSelector,
  accommodationsSelector,
  checkInSelector,
  checkOutSelector,
  currentStayAmountSelector,
  currentInventoryNameSelector,
  currentOccupantsSelector,
  datesModificationRestrictionTypeSelector,
  inventoriesSelector,
  isLoadingSelector,
  isModificationSuccessSelector,
  isModificationAvailableSelector,
  numberOfNightsSelector,
  roomStayIdSelector,
  tempReservationAmountSelector,
  tempReservationInventoryNameSelector,
  newModificationPriceSelector,
  guestsSelector,
  accommodationTypeSelector,
  currentInventorySelector,
  currentAccommodationMediaSelector,
  mealPlanSelector,
  conditionSelector,
  subTotalAmountSelector,
  discountsSelector,
  selectedServicesSelector,
  totalAmountSelector,
  tempReservationSelector,
  roomStayConfirmationIdSelector,
  accommodationARISelector,
  ageSelectorFieldsSelector,
  newCheckInSelector,
  areReservationExtrasModifiableSelector,
  areReservationDatesModifiableSelector,
  isReservationAccommodationModifiableSelector,
  newCheckOutSelector,
  accommodationQuantitySelector,
  modificationPolicySelector,
  serviceRatesInfoSelector,
  newInventorySelector,
  subTotalAmountWithDiscountsSelector,
  conditionsSelector,
  extrasSelector,
  extrasComparisonInfoSelector,
  currentExtrasAmountSelector,
  newExtrasAmountSelector,
  tempReservationExtrasSelector,
  cancellationRestrictionsModificationSelector,
  CancellationPoliciesInfoModificationSelector,
  guestsListSelector,
} from "./selectors";
import withRouterV4 from "../../components/RouterV4HOC/RouterV4HOC";
import Modal from "../../components/Modal/Modal";
import constants from "../../utils/constants";
import EntityCarousel from "../../components/EntityCarousel/EntityCarousel";
import InventoryList from "../../components/InventoryList/InventoryList";
import AgeSelector from "../../components/BookingForm/AgeSelector";
import media from "../../utils/media";
import style from "./styles.scss";
import { propertyFiltersSelector } from "../App/selectors";
import GlobalLoader from "../../components/GlobalLoader";
import { extrasQuestionnaireSelector } from "../ReservationManager/selectors";

const selectors = {
  ...appSelectors,
  ...checkoutSelectors,
  ...reservationSelectors,
};

const DivGridContainer = styled.div`
  display: grid;
  grid-template: auto/ 100%;
  & > * {
    border: 1px solid #e1e1e1;
    padding: 20px;
  }
  & > :first-child {
    order: 2;
    padding: 0;
    border-top: 0;
  }

  ${media.up.sml`
       & > :nth-child(1) { order: 0;
          border-top: 1px solid #e1e1e1;}
  grid-template: auto/ 50% 50%;
    & > :nth-child(2) {
    border-left: 0;
  }
  `};

  ${media.up.mdl`
  grid-template: auto/ 33% 33% 33%;
  `};
`;

const StyledPriceBreakdown = styled(PriceBreakdown)`
  margin-top: 25px;
  font-size: 14px;
`;

const PropertyInfo = styled.div`
  font-size: 14px;
  text-align: left;
`;

const AccommodationImg = styled.img`
  width: 100%;
`;

const PropertyHeader = styled.div`
  font-size: 20px;
  font-weight: 700;
  border-bottom: 1px solid #e1e1e1;
  background-color: #f6f6f6;
  padding: 10px 15px;
  ${media.up.sml`
   padding: 20px 20px 0 20px;
  background-color:transparent;
 border: 0;
  `};
`;

const PropertyBody = styled.div`
  padding: 20px;
  & img {
    margin-bottom: 20px;
  }
`;

const Message = styled.div`
  color: #b20e0e;
  background-color: #f7e6e6;
  margin-bottom: 25px;
  padding: 15px;
  border-radius: 5px;
  font-weight: 700;
  text-align: center;
`;

const StyledCommentExtrasBox = styled.div`
  text-align: left;
  white-space: pre-wrap;
  border-radius: 3px;
  border: 1px solid #e1e1e1;
  background-color: #f6f6f6;
  font-size: 13px;
  padding: 10px;
  word-wrap: break-word;
`;

const msgs = defineMessages({
  Title: {
    id: "bookingModification.modify.title",
    description: "Header title for modification",
    defaultMessage: "modify your booking",
  },
  SubTitle: {
    id: "bookingModification.modify.subtitle",
    description: "Header subtitle for modification",
    defaultMessage: "available only for direct bookings",
  },
  noRooms: {
    id: "bookingModification.modalAccommodation.notAvailable",
    description: "Message when no results are given",
    defaultMessage: "No rooms available",
  },
});

class BookingModification extends Component {
  constructor(props) {
    super(props);

    this.originalCheckIn = this.props.checkIn;
    this.originalCheckOut = this.props.checkOut;
    this.originalGuests = this.props.guests;
    this.originalRoomType = this.props.accommodationType;
    this.baseURL = "";
  }

  componentDidMount() {
    this.props.requestReservationARI({
      propertyTicker: this.props.propertyTicker,
      startDate: moment(this.props.checkIn).format("YYYY-MM-DD"),
      endDate: moment(this.props.checkOut).format("YYYY-MM-DD"),
      inventory: this.props.currentInventory,
      locale: this.props.locale,
      ignoredConfiguration: true,
      deviceInfo: this.props.deviceInfo.toJS(),
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isModificationSuccess !== this.props.isModificationSuccess &&
      this.props.isModificationSuccess
    ) {
      if (this.props.location.pathname.indexOf("modify-dates") >= 0) {
        this.props.history.push(`${this.props.match.url}modify-dates/success`);
      } else {
        this.props.history.push(`${this.props.match.url}modify-accommodation/success`);
      }
    }

    // First condition when searching dates that have no availability
    // Second condition when back button is clicked on confirm modification screen
    if (
      (this.props.accommodationARI !== prevProps.accommodationARI &&
        this.props.isModificationAvailable === false) ||
      (this.props.accommodationARI &&
        !prevProps.accommodationARI &&
        this.props.isModificationAvailable === null)
    ) {
      if (this.props.location.pathname.indexOf("modify-dates") >= 0) {
        this.props.history.push(`${this.props.match.url}modify-dates/calendar`);
      }
    }

    if (
      this.props.isModificationSuccess !== prevProps.isModificationSuccess &&
      this.props.isModificationSuccess
    ) {
      this.props.requestReservation({
        propertyTicker: this.props.propertyTicker,
        locale: this.props.locale,
        reservationId: this.props.reservationId,
      });

      this.props.requestReservationARI({
        propertyTicker: this.props.propertyTicker,
        startDate: moment(this.props.newCheckIn).format("YYYY-MM-DD"),
        endDate: moment(this.props.newCheckOut).format("YYYY-MM-DD"),
        inventory: this.props.newInventory,
        locale: this.props.locale,
        ignoredConfiguration: true,
        deviceInfo: this.props.deviceInfo.toJS(),
      });
    }
  }

  handleStartExtrasModification = () => {
    this.props.resetState();
    const checkIn = this.props.reservation.get("roomReservations").get(0).get("checkIn");
    const checkOut = this.props.reservation.get("roomReservations").get(0).get("checkOut");
    this.props.requestModificationARI({
      propertyTicker: this.props.propertyTicker,
      startDate: moment(checkIn).format("YYYY-MM-DD"),
      endDate: moment(checkOut).format("YYYY-MM-DD"),
      locale: this.props.locale,
      seniors: this.props.currentOccupants.seniors,
      adults: this.props.currentOccupants.adults,
      teenagers: this.props.currentOccupants.teenagers,
      children: this.props.currentOccupants.children,
      babies: this.props.currentOccupants.babies,
      childrenCount: this.props.currentOccupants.childrenCount,
      ignoredConfiguration: false,
      deviceInfo: this.props.deviceInfo.toJS(),
    });
    this.props.history.push(`${this.baseURL}/modify-extras/extras-selection`);
  };
  handleStartAccommodationModification = () => {
    this.props.resetState();
    this.props.requestModificationARI({
      propertyTicker: this.props.propertyTicker,
      startDate: moment(this.props.checkIn).format("YYYY-MM-DD"),
      endDate: moment(this.props.checkOut).format("YYYY-MM-DD"),
      locale: this.props.locale,
      seniors: this.props.currentOccupants.seniors,
      adults: this.props.currentOccupants.adults,
      teenagers: this.props.currentOccupants.teenagers,
      children: this.props.currentOccupants.children,
      babies: this.props.currentOccupants.babies,
      childrenCount: this.props.currentOccupants.childrenCount,
      ignoredConfiguration: false,
      deviceInfo: this.props.deviceInfo.toJS(),
    });
    this.props.history.push(`${this.baseURL}/modify-accommodation/room-selection`);
  };

  handleStartDatesModification = () => {
    this.props.resetState();
    this.props.history.push(`${this.baseURL}/modify-dates/calendar`);
  };

  handleOpenConditions = () => {
    // FIXME: this is not going to work in multiple reservations
    this.props.handleModalContent(
      <Conditions.PopupConditions
        data={this.props.conditions.toJS()}
        closeWindow={this.props.handleCloseModal}
        restrictions={this.props.cancellationRestrictionsModification}
        cancellationPoliciesInfo={this.props.cancellationPoliciesInfo}
        checkIn={this.props.reservation.getIn(["roomReservations", "0", "checkIn"])}
        amount={this.props.reservation.getIn(["roomReservations", "0", "totalAmount", "amount"])}
        currency={this.props.reservation.getIn([
          "roomReservations",
          "0",
          "totalAmount",
          "currency",
        ])}
        firstNightCost={this.props.reservation.getIn([
          "roomReservations",
          "0",
          "dailyValues",

          Object.keys(
            this.props.reservation.getIn(["roomReservations", "0", "dailyValues"]).toJS()
          )[0],
          "amount",
        ])}
        cutOffDate={this.props.reservation.getIn(["placementDate"])}
        showCancellationTable
      />,
      { hideCloseButton: true }
    );
  };

  handleUpdateExtras = ({ quantity, forms }) => {
    this.props.selectExtras({ quantity, forms });
    this.props.history.push(`${this.baseURL}/modify-extras/confirm`);
  };

  handleUpdateRooms = ({
    seniors,
    adults,
    teenagers,
    children,
    babies,
    childrenCount,
    guestAges,
  }) => {
    this.props.requestModificationARI({
      propertyTicker: this.props.propertyTicker,
      startDate: moment(this.props.checkIn).format("YYYY-MM-DD"),
      endDate: moment(this.props.checkOut).format("YYYY-MM-DD"),
      locale: this.props.locale,
      ignoredConfiguration: false,
      seniors,
      adults,
      teenagers,
      children,
      babies,
      childrenCount,
      guestAges,
    });
  };

  handleCancelModification = () => {
    this.props.history.push(this.baseURL);
  };

  handleConfirmModification = async () => {
    await this.props.modifyReservation(this.props.tempReservation, true);
  };

  handleSelectAccommodation = accommodation => {
    this.props.selectAccommodation(accommodation);
    this.props.history.push(`${this.baseURL}/modify-accommodation/rate-selection`);
  };

  handleSelectInventory = ({ inventory, numberOfUnits }) => {
    this.props.selectInventory({
      inventory: inventory.get("ticker"),
      numberOfUnits,
    });

    this.props.history.push(`${this.baseURL}/modify-accommodation/confirm`);
  };

  handleSelectDates = ({ startDate, endDate }) => {
    this.props.selectDates({ checkIn: startDate, checkOut: endDate });
    this.props.requestModificationARI({
      startDate,
      endDate,
      locale: this.props.locale,
      propertyTicker: this.props.propertyTicker,
      deviceInfo: this.props.deviceInfo.toJS(),
    });
    this.props.history.push(`${this.props.match.url}modify-dates/confirm`);
  };

  handleChangeLocale = newConfiguration => {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
    this.props.changeLocale({
      propertyTicker: this.props.propertyTicker,
      locale: newConfiguration.locale,
    });
  };

  handleChangeConfiguration = newConfiguration => {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
  };

  handleGoToConfirmation = () => {
    const newUrl = document.URL.replace(constants.STEP_PATHS.STEP_4, constants.STEP_PATHS.STEP_3);
    //Push won't work here due to routerv4
    window.location = newUrl;
  };

  handleServiceGallery = service => {
    this.props.handleGallery(
      service.media && service.media.length !== 0 ? service.media : [constants.DEFAULT_EXTRA_MEDIA],
      service.name,
      service.description,
      {},
      null,
      null,
      "service"
    );
  };

  render() {
    const { handleChangeLocale, handleChangeConfiguration } = this;
    const {
      propertyContact,
      propertyName,
      handleModalContent,
      fullWidth,
      isAgent,
      affiliate,
      generateMapView,
      currency,
      showElementsConfig,
      locale,
      availableLocales,
      availableCurrencies,
      promoCode,
      toggleBookingFormSummary,
      areReservationExtrasModifiable,
      areReservationDatesModifiable,
      isReservationAccommodationModifiable,
      serviceRatesInfo,
      windowWidth,
      propertyFilters,
      guestsList,
    } = this.props;
    const modalOptions = {
      styles: {
        overlay: {
          zIndex: "1499",
        },
        content: {
          maxWidth: "930px",
          zIndex: "1499",
          overflow: "hidden",
        },
      },
      className: "fullWidthMode",
      hideCloseButton: true,
    };

    const roomList =
      this.props.accommodations && this.props.accommodations.size > 0 ? (
        <EntityCarousel
          type="accommodation"
          entities={this.props.accommodations}
          onSelect={this.handleSelectAccommodation}
          handleGallery={this.props.handleGallery}
          propertyTicker={this.props.propertyTicker}
          handleScroll={this.props.handleScroll}
          roomRepresentationType={constants.ROOM_REPRESENTATION_TYPE.HORIZONTAL}
          fullWidth
          windowWidth={windowWidth}
          propertyFiltersShown={propertyFilters && propertyFilters.size > 0}
        />
      ) : (
        <Message>
          <FormattedMessage {...msgs.noRooms} />
        </Message>
      );
    const checkInChanged = !moment(this.props.checkIn).isSame(moment(this.originalCheckIn));
    const checkOutChanged = !moment(this.props.checkOut).isSame(moment(this.originalCheckOut));

    const guestsChanged = this.props.guests !== this.originalGuests;
    const roomTypeChanged = this.props.accommodationType !== this.originalRoomType;

    const inventoryList = this.props.accommodation ? (
      <InventoryList
        propertyTicker={this.props.propertyTicker}
        startDate={this.props.checkIn}
        endDate={this.props.checkOut}
        accommodationTicker={this.props.accommodation.ticker}
        accommodationName={this.props.accommodation.name}
        calendarPriceVisibility={this.props.openCalendar}
        cancelRelease={this.props.cancelRelease}
        currency={this.props.currency}
        handleCloseModal={this.props.handleCloseModal}
        handleModalContent={this.props.handleModalContent}
        handleScroll={this.props.handleScroll}
        inventories={this.props.inventories}
        inventoryGroupingCriteria={this.props.inventoryGroupingCriteria}
        maxBookableRooms={this.props.maxBookableRooms}
        numberOfNights={this.props.numberOfNights}
        numberOfRoomsLeftLimit={this.props.numberOfRoomsLeftLimit}
        onSelect={this.handleSelectInventory}
        roomDetailRepresentationType={constants.ROOM_DETAIL_REPRESENTATION_TYPE.FULL}
        showBookingOptionSummary={this.props.showBookingOptionSummary}
        showDiscountsCalculation={this.props.showDiscountsCalculation}
        submitBookingForm={() => undefined}
        cancellationRestrictions={this.props.cancellationRestrictionsModification}
        inModification
        depositRequiredTextConfiguration={this.props.depositRequiredTextConfiguration}
        depositNotRequiredTextConfiguration={this.props.depositNotRequiredTextConfiguration}
      />
    ) : (
      <div>No accommodation selected</div>
    );

    let occupantSelector = undefined;
    let occupantFields = undefined;
    if (this.props.ageSelectorFields) {
      const enabledSelectors = Object.keys(this.props.ageSelectorFields.fields).filter(
        key => this.props.ageSelectorFields.fields[key] && key !== "childrenCount"
      );
      const enabledSelectorsAll = Object.keys(this.props.ageSelectorFields.fields).filter(
        key => this.props.ageSelectorFields.fields[key]
      );
      occupantFields = enabledSelectorsAll.map(it => ({
        name: it,
        value: undefined,
        onChange: undefined,
      }));
      const childrenAgeRange =
        this.props.ageSelectorFields.selectorsRange.childrenAges || undefined;
      occupantSelector = (
        <AgeSelector
          enabledSelectors={enabledSelectors}
          ageRanges={this.props.ageSelectorFields.ageRanges}
          fields={{}}
          childrenAgeRange={childrenAgeRange}
          selectorsRange={this.props.ageSelectorFields.selectorsRange}
          fullWidth
        />
      );
    }
    const currentExtrasStringList =
      this.props.extrasComparisonInfo.currentExtras &&
      this.props.extrasComparisonInfo.currentExtras
        .map(it => it.name)
        .sort()
        .join(", ");
    const extraComments = this.props.reservation.getIn(["roomReservations", "0", "comments"]);
    return (
      <div className={style.bookingModification}>
        <ModficationResultHeader
          onBack={this.handleGoToConfirmation}
          nature="medium"
          hasBackButton
          title={<FormattedMessage {...msgs.Title} />}
          subtitle={<FormattedMessage {...msgs.SubTitle} />}
          titleColor="#329911"
          titleWeight={400}
          className={"wbkv9-ModificationResultHeader"}
          titleUppercase={false}
        />
        <Route
          path={`${this.baseURL}/modify-dates/:step`}
          render={({
            match: {
              params: { step },
            },
          }) => (
            <Modal
              isOpen
              options={modalOptions}
              closeModal={this.handleCancelModification}
              iframeMode={false}>
              <ModifyReservationWizardDates
                step={step}
                closeWindow={this.handleCancelModification}
                isAvailable={this.props.isModificationAvailable}
                loading={this.props.isLoading}
                newAmount={this.props.tempReservationAmount}
                isSuccessful={this.props.isModificationSuccess}
                reset={this.props.history.goBack}
                onConfirmDates={this.handleSelectDates}
                checkIn={this.props.newCheckIn}
                checkOut={this.props.newCheckOut}
                originalCheckIn={this.props.checkIn}
                originalCheckOut={this.props.checkOut}
                currentAmount={this.props.currentStayAmount}
                datesModificationRestrictionType={this.props.datesModificationRestrictionType}
                propertyTicker={this.props.propertyTicker}
                currency={this.props.currency}
                currentInventoryName={this.props.currentInventoryName}
                newInventoryName={this.props.tempReservationInventoryName}
                onConfirmModification={this.handleConfirmModification}
                isModificationSuccess={this.props.isModificationSuccess}
                oldExtras={currentExtrasStringList}
                newExtras={this.props.tempReservationExtras}
              />
            </Modal>
          )}
        />
        <Route
          path={`${this.baseURL}/modify-accommodation/:step`}
          render={({
            match: {
              params: { step },
            },
          }) => (
            <Modal
              isOpen
              options={modalOptions}
              closeModal={this.handleCancelModification}
              iframeMode={false}>
              <ModifyReservationWizardAccommodation
                step={step}
                goBack={this.props.history.goBack}
                className="ModifyReservationWizardAccommodationPopup1"
                onClose={this.handleCancelModification}
                onCancel={this.handleCancelModification}
                onConfirmModification={this.handleConfirmModification}
                updateRooms={this.handleUpdateRooms}
                loading={this.props.isLoading}
                seniors={this.props.currentOccupants && this.props.currentOccupants.seniors}
                adults={this.props.currentOccupants && this.props.currentOccupants.adults}
                teenagers={this.props.currentOccupants && this.props.currentOccupants.teenagers}
                kids={this.props.currentOccupants && this.props.currentOccupants.children}
                babies={this.props.currentOccupants && this.props.currentOccupants.babies}
                childrenCount={
                  this.props.currentOccupants && this.props.currentOccupants.childrenCount
                }
                guestAges={this.props.currentOccupants && this.props.currentOccupants.guestAges}
                checkIn={this.props.checkIn}
                checkOut={this.props.checkOut}
                currentInventoryName={this.props.currentInventoryName}
                accommodationModificationRestrictionType={
                  this.props.accommodationModificationRestrictionType
                }
                newAmount={this.props.tempReservationAmount}
                currentAmount={this.props.currentStayAmount}
                currency={this.props.currency}
                newInventoryName={this.props.tempReservationInventoryName}
                rooms={roomList}
                inventories={inventoryList}
                occupantSelector={occupantSelector}
                occupantFields={occupantFields}
                isModificationSuccess={this.props.isModificationSuccess}
                oldExtras={currentExtrasStringList}
                newExtras={this.props.tempReservationExtras}
              />
            </Modal>
          )}
        />
        <Route
          path={`${this.baseURL}/modify-extras/:step`}
          render={({
            match: {
              params: { step },
            },
          }) => (
            <Modal
              isOpen
              options={modalOptions}
              closeModal={this.handleCancelModification}
              iframeMode={false}>
              <ModifyReservationWizardExtras
                step={step}
                goBack={this.props.history.goBack}
                className="ModifyReservationWizardAccommodationExtras"
                onClose={this.handleCancelModification}
                onCancel={this.handleCancelModification}
                onConfirmModification={this.handleConfirmModification}
                updateExtras={this.handleUpdateExtras}
                loading={this.props.isLoading}
                checkIn={this.props.checkIn}
                checkOut={this.props.checkOut}
                currentAmount={this.props.currentExtrasAmount}
                newAmount={this.props.newExtrasAmount}
                currentInventoryName={this.props.currentInventoryName}
                newInventoryName={this.props.tempReservationInventoryName}
                currency={this.props.currency}
                isModificationSuccess={this.props.isModificationSuccess}
                extras={this.props.extras}
                selectedServices={this.props.selectedServices}
                handleGallery={this.handleServiceGallery}
                serviceHasImage={this.props.serviceHasImage}
                addObligatoryExtrasRateToRoomSelection={
                  this.props.addObligatoryExtrasRateToRoomSelection
                }
                currentExtras={this.props.extrasComparisonInfo.currentExtras}
                newExtras={this.props.extrasComparisonInfo.newExtras}
                questionnaires={this.props.extrasQuestionnaire}
                serviceRatesInfo={serviceRatesInfo}
                guestsList={guestsList}
              />
            </Modal>
          )}
        />
        <ModificationButtonBar
          datesFunction={this.handleStartDatesModification}
          modifyFunction={this.handleStartAccommodationModification}
          extrasFunction={this.handleStartExtrasModification}
          cancelFunction={() => null}
          areReservationDatesModifiable={areReservationDatesModifiable.isModifiable}
          isReservationAccommodationModifiable={isReservationAccommodationModifiable.isModifiable}
          areReservationExtrasModifiable={areReservationExtrasModifiable.isModifiable}
          isCancelActive={false}
          untilDateDates={areReservationDatesModifiable.dateOfExpiration}
          untilDateModify={isReservationAccommodationModifiable.dateOfExpiration}
          untilDateExtras={areReservationExtrasModifiable.dateOfExpiration}
          untilDateCancel={Date.now()}
        />
        <DivGridContainer>
          <PropertyInfo>
            <PropertyHeader>{propertyName}</PropertyHeader>
            <PropertyBody>
              {this.props.currentAccommodationMedia[0] && (
                <AccommodationImg src={this.props.currentAccommodationMedia[0].url} />
              )}
              <div>{propertyContact.get("address")}</div>
              <div>{propertyContact.get("contactEmail")}</div>
              <div>{propertyContact.get("phone")}</div>
            </PropertyBody>
          </PropertyInfo>
          <div>
            <ModifyReservationChangesSummary
              reservation={this.props.roomStayConfirmationId}
              reservationRef={this.props.roomStayId}
              checkIn={this.props.checkIn}
              checkInChanged={checkInChanged}
              checkOut={this.props.checkOut}
              checkOutChanged={checkOutChanged}
              guests={this.props.guests}
              guestsChanged={guestsChanged}
              roomType={this.props.accommodationType}
              roomTypeChanged={roomTypeChanged}
              mealPlan={this.props.mealPlan}
              conditionName={this.props.condition}
              accommodationQuantity={this.props.accommodationQuantity}
              handleConditions={this.handleOpenConditions}
              restrictions={this.props.cancellationRestrictionsModification}
              cancellationPoliciesInfo={this.props.cancellationPoliciesInfo}
              cutOffDate={moment(this.props.reservation.get("placementDate")).toDate()}
            />
            <StyledPriceBreakdown
              discountAmount={this.props.subTotalAmount - this.props.subTotalAmountWithDiscounts}
              baseRate={this.props.subTotalAmount}
              currency={currency}
              discountDiff={this.props.subTotalAmountWithDiscounts}
              hasDiscounts={this.props.discounts.size > 0}
              hasSelectedServices={
                this.props.selectedServices && Object.keys(this.props.selectedServices).length > 0
              }
              addObligatoryExtrasRateToRoomSelection={
                this.props.addObligatoryExtrasRateToRoomSelection
              }
              selectedServices={this.props.selectedServices}
              serviceRatesInfo={serviceRatesInfo}
              totalRate={this.props.totalAmount}
              inModifyReservation
            />
            {extraComments && <StyledCommentExtrasBox>{extraComments}</StyledCommentExtrasBox>}
          </div>
        </DivGridContainer>
        <Footer
          fullWidth={fullWidth}
          isAgentLogged={isAgent}
          affiliate={affiliate}
          propertyName={propertyName}
          propertyContact={propertyContact}
          handleMap={() =>
            handleModalContent(generateMapView(true), {
              mobileMode: true,
              className: "wbkv9-Modal-mapModal",
            })
          }
          showLanguage={showElementsConfig.showLanguageSelector}
          showCurrency={showElementsConfig.showCurrencySelector}
          locale={locale}
          currency={currency}
          locales={availableLocales}
          currencies={availableCurrencies}
          onLanguageChange={handleChangeLocale}
          onCurrencyChange={handleChangeConfiguration}
          promoCode={promoCode}
          toggleBookingFormSummary={toggleBookingFormSummary}
          handleCloseModal={this.props.handleCloseModal}
          handleModalContent={handleModalContent}
        />
      </div>
    );
  }
}

BookingModification.defaultProps = {
  accommodation: {},
  accommodationARI: {},
  affiliate: "",
  discounts: {},
  inventories: {},
  isAgent: false,
  tempReservation: {},
  tempReservationAmount: 0,
  tempReservationInventoryName: "",
  subTotalAmountWithDiscounts: 0,
  cancellationRestrictionsModification: undefined,
  cancellationPoliciesInfo: undefined,
};
BookingModification.propTypes = {
  windowWidth: PropTypes.number,
  accommodation: PropTypes.object,
  accommodationARI: PropTypes.object,
  accommodationQuantity: PropTypes.number.isRequired,
  accommodationType: PropTypes.string.isRequired,
  accommodations: PropTypes.any.isRequired,
  accommodationModificationRestrictionType: PropTypes.string.isRequired,
  addAlert: PropTypes.func.isRequired,
  addObligatoryExtrasRateToRoomSelection: PropTypes.bool.isRequired,
  affiliate: PropTypes.string,
  ageSelectorFields: PropTypes.object.isRequired,
  areReservationDatesModifiable: PropTypes.object.isRequired,
  areReservationExtrasModifiable: PropTypes.object.isRequired,
  availableCurrencies: PropTypes.object.isRequired,
  availableLocales: PropTypes.object.isRequired,
  cancelRelease: PropTypes.number.isRequired,
  changeConfiguration: PropTypes.func.isRequired,
  changeLocale: PropTypes.func.isRequired,
  checkIn: PropTypes.instanceOf(Date).isRequired,
  checkOut: PropTypes.instanceOf(Date).isRequired,
  clearData: PropTypes.func.isRequired,
  condition: PropTypes.string.isRequired,
  configuration: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired,
  currentAccommodationMedia: PropTypes.array.isRequired,
  currentInventory: PropTypes.string.isRequired,
  currentInventoryName: PropTypes.string.isRequired,
  currentOccupants: PropTypes.object.isRequired,
  currentStayAmount: PropTypes.number.isRequired,
  datesModificationRestrictionType: PropTypes.string.isRequired,
  defaultCurrency: PropTypes.string.isRequired,
  discounts: PropTypes.object,
  fullWidth: PropTypes.bool.isRequired,
  generateMapView: PropTypes.func.isRequired,
  guests: PropTypes.number.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  handleModalContent: PropTypes.func.isRequired,
  handleScroll: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  inventories: PropTypes.object,
  inventoryGroupingCriteria: PropTypes.object.isRequired,
  isAgent: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  isModificationAvailable: PropTypes.bool,
  isModificationSuccess: PropTypes.bool,
  isReservationAccommodationModifiable: PropTypes.object,
  serviceRatesInfo: PropTypes.array,
  locale: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  maxBookableRooms: PropTypes.number.isRequired,
  mealPlan: PropTypes.string.isRequired,
  modifyReservation: PropTypes.func.isRequired,
  newCheckIn: PropTypes.instanceOf(Date),
  newCheckOut: PropTypes.instanceOf(Date),
  newInventory: PropTypes.string.isRequired,
  numberOfNights: PropTypes.number.isRequired,
  numberOfRoomsLeftLimit: PropTypes.number.isRequired,
  openCalendar: PropTypes.func.isRequired,
  promoCode: PropTypes.string.isRequired,
  propertyContact: PropTypes.object.isRequired,
  propertyName: PropTypes.string.isRequired,
  propertyTicker: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  requestModificationARI: PropTypes.func.isRequired,
  requestReservation: PropTypes.func.isRequired,
  requestReservationARI: PropTypes.func.isRequired,
  reservation: PropTypes.object.isRequired,
  resetState: PropTypes.func.isRequired,
  roomStayConfirmationId: PropTypes.string.isRequired,
  roomStayId: PropTypes.string.isRequired,
  selectAccommodation: PropTypes.func.isRequired,
  selectDates: PropTypes.func.isRequired,
  selectInventory: PropTypes.func.isRequired,
  selectedServices: PropTypes.object.isRequired,
  showBookingOptionSummary: PropTypes.bool.isRequired,
  showDiscountsCalculation: PropTypes.bool.isRequired,
  showElementsConfig: PropTypes.object.isRequired,
  subTotalAmount: PropTypes.number.isRequired,
  tempReservation: PropTypes.object,
  tempReservationAmount: PropTypes.number,
  tempReservationInventoryName: PropTypes.string,
  toggleBookingFormSummary: PropTypes.func.isRequired,
  totalAmount: PropTypes.number.isRequired,
  subTotalAmountWithDiscounts: PropTypes.number,
  conditions: PropTypes.object.required,
  extras: PropTypes.array.required,
  serviceHasImage: PropTypes.bool.required,
  selectExtras: PropTypes.func.required,
  extrasComparisonInfo: PropTypes.shape({
    currentExtras: PropTypes.array,
    newExtras: PropTypes.array,
  }).required,
  currentExtrasAmount: PropTypes.number.required,
  newExtrasAmount: PropTypes.number.required,
  handleGallery: PropTypes.func.required,
  tempReservationExtras: PropTypes.string,
  cancellationRestrictionsModification: PropTypes.array,
  cancellationPoliciesInfo: PropTypes.array,
  deviceInfo: PropTypes.string,
  params: PropTypes.object,
  propertyFilters: PropTypes.bool.object,
  guestsList: PropTypes.bool.object,
};

const ConnectedBookingModification = connect(
  createStructuredSelector({
    pendingAmountTextConfiguration: selectors.pendingAmountTextConfigurationSelector,
    addObligatoryExtrasRateToRoomSelection:
      selectors.addObligatoryExtrasRateToRoomSelectionSelector,
    reservation: selectors.reservationSelector,
    locale: selectors.localeSelector,
    windowWidth: selectors.widthSelector,
    propertyTicker: selectors.propertyTickerSelector,
    propertyContact: selectors.propertyContactSelector,
    propertyName: selectors.propertyNameSelector,
    cancelRelease: selectors.cancelReleaseSelector,
    countries: selectors.countriesSelector,
    currency: selectors.currencySelector,
    defaultCurrency: selectors.defaultCurrencySelector,
    isAnalyticsLoaded: selectors.analyticsLoadedSelector,
    isTripAdvisorLoaded: selectors.tripAdvisorLoadedSelector,
    isExternalMarkupLoaded: selectors.externalMarkupLoadedSelector,
    fullWidth: selectors.fullWidthSelector,
    media: selectors.mediaSelector,
    creditCardTypes: selectors.creditCardTypesSelector,
    reservationCreated: selectors.reservationCreatedSelector,
    externalReservation: selectors.externalReservationSelector,
    iframeMode: selectors.iframeModeSelector,
    showElementsConfig: selectors.showElementsConfigSelector,
    availableLocales: selectors.availableLocalesSelector,
    availableCurrencies: selectors.availableCurrenciesSelector,
    promoCode: selectors.promoCodeSelector,
    hotelSiteURL: selectors.hotelSiteURLSelector,
    deviceInfo: selectors.deviceInfoSelector,
    isLoading: isLoadingSelector,
    isModificationSuccess: isModificationSuccessSelector,
    checkIn: checkInSelector,
    checkOut: checkOutSelector,
    newCheckIn: newCheckInSelector,
    newCheckOut: newCheckOutSelector,
    accommodationModificationRestrictionType: accommodationModificationRestrictionTypeSelector,
    datesModificationRestrictionType: datesModificationRestrictionTypeSelector,
    currentInventoryName: currentInventoryNameSelector,
    currentOccupants: currentOccupantsSelector,
    newModificationPrice: newModificationPriceSelector,
    currentStayAmount: currentStayAmountSelector,
    accommodations: accommodationsSelector,
    accommodation: accommodationSelector,
    inventories: inventoriesSelector,
    inventoryGroupingCriteria: selectors.inventoryGroupingCriteriaSelector,
    maxBookableRooms: selectors.maxBookableRoomsSelector,
    numberOfNights: numberOfNightsSelector,
    numberOfRoomsLeftLimit: selectors.numberOfRoomsLeftLimitSelector,
    showBookingOptionSummary: selectors.showBookingOptionSummarySelector,
    showDiscountsCalculation: selectors.showDiscountsCalculationSelector,
    roomStayId: roomStayIdSelector,
    tempReservationAmount: tempReservationAmountSelector,
    tempReservationInventoryName: tempReservationInventoryNameSelector,
    isModificationAvailable: isModificationAvailableSelector,
    guests: guestsSelector,
    accommodationType: accommodationTypeSelector,
    currentInventory: currentInventorySelector,
    currentAccommodationMedia: currentAccommodationMediaSelector,
    mealPlan: mealPlanSelector,
    condition: conditionSelector,
    subTotalAmount: subTotalAmountSelector,
    discounts: discountsSelector,
    selectedServices: selectedServicesSelector,
    totalAmount: totalAmountSelector,
    tempReservation: tempReservationSelector,
    roomStayConfirmationId: roomStayConfirmationIdSelector,
    accommodationARI: accommodationARISelector,
    ageSelectorFields: ageSelectorFieldsSelector,
    accommodationQuantity: accommodationQuantitySelector,
    areReservationExtrasModifiable: areReservationExtrasModifiableSelector,
    areReservationDatesModifiable: areReservationDatesModifiableSelector,
    isReservationAccommodationModifiable: isReservationAccommodationModifiableSelector,
    isAgent: selectors.isAgentSelector,
    affiliate: selectors.affiliateSelector,
    showAgentLogin: selectors.showAgentLoginSelector,
    modificationPolicy: modificationPolicySelector,
    newInventory: newInventorySelector,
    serviceRatesInfo: serviceRatesInfoSelector,
    subTotalAmountWithDiscounts: subTotalAmountWithDiscountsSelector,
    conditions: conditionsSelector,
    extras: extrasSelector,
    serviceHasImage: selectors.serviceHasImageSelector,
    extrasComparisonInfo: extrasComparisonInfoSelector,
    currentExtrasAmount: currentExtrasAmountSelector,
    newExtrasAmount: newExtrasAmountSelector,
    tempReservationExtras: tempReservationExtrasSelector,
    propertyFilters: propertyFiltersSelector,
    cancellationRestrictionsModification: cancellationRestrictionsModificationSelector,
    cancellationPoliciesInfo: CancellationPoliciesInfoModificationSelector,
    extrasQuestionnaire: extrasQuestionnaireSelector,
    guestsList: guestsListSelector,
    depositRequiredTextConfiguration: selectors.depositRequiredTextConfigurationSelector,
    depositNotRequiredTextConfiguration: selectors.depositNotRequiredTextConfigurationSelector,
  }),
  dispatch => bindActionCreators({ ...actions, ...appActions }, dispatch)
)(withRouterV4(withRouter(BookingModification)));

export default function (props) {
  const isReservationLoaded = !!useSelector(reservationSelector);
  const configuration = useSelector(selectors.configurationSelector);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (!isReservationLoaded) {
      const query = (location && location.search && queryStringParse(location.search)) || {};
      const urlParams = {
        hotelTicker: props.hotelTicker,
        reservationId: props.reservationId,
        ...query,
      };
      dispatch(appActions.requestReservationData(urlParams));
    }
  }, []);

  return isReservationLoaded && configuration ? (
    <ConnectedBookingModification
      configuration={configuration}
      reservationId={props.reservationId}
      {...props}
    />
  ) : (
    <GlobalLoader />
  );
}
